import { render } from "./DefaultPage.vue?vue&type=template&id=c6dbab20&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"

import "./DefaultPage.vue?vue&type=style&index=0&id=c6dbab20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6dbab20"],['__file',"src/components/DefaultPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6dbab20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6dbab20', __exports__)) {
    api.reload('c6dbab20', __exports__)
  }
  
  module.hot.accept("./DefaultPage.vue?vue&type=template&id=c6dbab20&scoped=true", () => {
    api.rerender('c6dbab20', render)
  })

}


export default __exports__